import { ProductTypeEnum } from './enum';
// 常量定义
export const MMG_ACTIVITY = 'mmg.activity'; // 营销活动更新
export const MMG_ORDER_PLAN = 'mmg.orderPlan'; // 整单手动折扣
export const MMG_PRODUCT_PLAN = 'mmg.productPlan'; // 餐品手动折扣
export const AES_KEY = 'edgt-2m0m2g0';
export const GATEWAY = 'https://gateway.'; // 网关
export const MEMBER_SERVICE = 'memberservice';
export const MARKETING_SERVICE = 'marketingservice';
export const VERSION = '3.3.2'; // 版本号
export const DEFAULT_FORMAT = 'YYYY-MM-DD HH:mm:ss'; // 默认格式
export const COMBOS = [ProductTypeEnum.FixedCombo, ProductTypeEnum.OptionalCombo]; // 套餐
//# sourceMappingURL=constant.js.map